import React, { useMemo } from 'react'

import { WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import { RoleLevelAssignationForm } from 'modules/competencies/components/RoleLevelAssignationForm'
import { type WizardData } from 'modules/competencies/pages/CompetenciesList/NewCompetencyWizard/types'

interface Props extends WizardStepRenderParams<WizardData> {}

export const AssignationStep: React.FC<Props> = ({ data, onDataChanged }) => {
  const { levels, name, jobCatalogTreeNodeUuids } = data

  const assignments = useMemo(
    () => ({
      competency: jobCatalogTreeNodeUuids ?? [],
      competencyLevels: Object.fromEntries(
        levels.map((level) => [level.id, level.jobCatalogTreeNodeUuids ?? []])
      ),
    }),
    [levels, jobCatalogTreeNodeUuids]
  )

  const onAssignToCompetencyLevel = (
    competencyLevelId: string | number,
    roleLevelUuids: string[]
  ) => {
    const newLevels = levels.map((level) =>
      level.id === competencyLevelId ? { ...level, jobCatalogTreeNodeUuids: roleLevelUuids } : level
    )

    onDataChanged({ ...data, levels: newLevels })
  }

  return (
    <RoleLevelAssignationForm
      competencyName={name}
      competencyLevels={levels}
      assignments={assignments}
      onAssignToCompetency={(uuids) => onDataChanged({ ...data, jobCatalogTreeNodeUuids: uuids })}
      onAssignToCompetencyLevel={onAssignToCompetencyLevel}
    />
  )
}
